module.exports = __webpack_public_path__ + "images/91e5c33.jpg";